<template>
  <!-- prettier-ignore -->
  <svg aria-hidden="true" focusable="false" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M10 3C4 3 0 10 0 10s4 7 10 7 10-7 10-7-4-7-10-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"/><path fill="currentColor" d="M8 9a1 1 0 0 0 .71-1.7A2.97 2.97 0 0 1 13 10a3 3 0 1 1-5.7-1.29A1 1 0 0 0 8 9z"/></svg>
</template>
